enum GeneralActionTypes {
  WAIT_FOR_URL_EXISTS = "@@GENERAL/WAIT_FOR_URL_EXISTS",
  CANCEL_URL_WAITING = "@@GENERAL/CANCEL_URL_WAITING",
}

export default GeneralActionTypes;
